module.exports = __webpack_public_path__ + "img/property-spec.8eb2e7ea.svg";